import React, { useEffect } from "react";
import { auth } from "../firebase-config";
import Logo from '../assets/Logo.webp';
import { onAuthStateChanged } from "firebase/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setUid } from "../redux/userReducer";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {


    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const userInfo = useSelector(state => state.user.user)
    const isStaff = userInfo && userInfo.role === 'staff'

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/login')
            } else {
                dispatch(setUid(user.uid))
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (isStaff && location.pathname !== '/calendar') {
            navigate('/calendar')
        }
    }, [isStaff, location.pathname])

    const signOutUser = async () => {
        await auth.signOut();
    }

    return (<div style={{ borderBottom: '1px solid #d3d3d3', paddingBottom: '10px', display: 'flex', alignItems: 'center', width: 'calc(100% - 20px)', justifyContent: 'space-between' }}>
        <img src={Logo} style={{ width: '120px', marginLeft: '20px' }} />
        {!isStaff && <Link className="textButton" style={{ textDecoration: 'none', color: (window.location.href.split('/')[3] === '' || window.location.href.includes('/?')) ? '#FF7100' : 'black' }} to={'/'}>Learn</Link>}
        {!isStaff && <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/entertainment') ? '#FF7100' : 'black' }} to={'/entertainment'}>Entertainment</Link>}
        {!isStaff && <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/testing') ? '#FF7100' : 'black' }} to={'/testing'}>Testing</Link>}
        {!isStaff && <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/users') ? '#FF7100' : 'black' }} to={'/users'}>Users</Link>}
        {!isStaff && <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/shop') ? '#FF7100' : 'black' }} to={'/shop'}>Shop</Link>}
        <Link className="textButton" style={{ textDecoration: 'none', color: window.location.href.includes('/calendar') ? '#FF7100' : 'black' }} to={'/calendar'}>Calendar</Link>
        <button style={{ marginTop: 0, padding: '10px', borderRadius: '4px' }} onClick={signOutUser}> Sign out</button>
    </div>)
}

export default Header
